function mapToOutputArray(input, options = {}) {
  if (!input) return;
  const {
    sourceTextKey = "text",
    extraFields = {},
    isStringArray = false,
  } = options;

  return input?.map((item) => {
    const dynamicExtras =
      typeof extraFields === "function" ? extraFields(item) : extraFields;
    return {
      text: isStringArray ? item : item?.[sourceTextKey],
      selected: false,
      ...dynamicExtras,
    };
  });
}

export function prepareFocusAreaOutput(
  {
    reach,
    sentimentDrivers,
    positiveSentimentDrivers,
    brand_pillars,
    purchase_criteria,
    positiveAttributesInput,
    negativeAttributesInput,
  },
  type
) {
  return {
    reach: mapToOutputArray(reach, { sourceTextKey: "text" }),
    sentimentDrivers:
      mapToOutputArray(sentimentDrivers, {
        sourceTextKey: "driver",
      }) || [],
    positiveSentimentDrivers: mapToOutputArray(positiveSentimentDrivers, {
      sourceTextKey: "driver",
    }),
    [type === "Product" ? "productDimensions" : "brandPillars"]:
      mapToOutputArray(brand_pillars, {
        sourceTextKey: "name",
        extraFields: (item) => ({
          score: item?.score,
          isActionable: item?.score <= 5,
        }),
      }),
    purchaseCriteria: mapToOutputArray(purchase_criteria, {
      sourceTextKey: "name",
      extraFields: (item) => ({
        score: item?.score,
        isActionable: item?.score <= 5,
      }),
    }),
    positiveAttributes: mapToOutputArray(positiveAttributesInput, {
      isStringArray: true,
    }),
    negativeAttributes: mapToOutputArray(negativeAttributesInput, {
      isStringArray: true,
    }),
  };
}

export const transformFocusArea = (data, type) => {
  const titleMapping = {
    reach: "Reach",
    positiveSentimentDrivers: "Positive_Sentiment_Drivers",
    sentimentDrivers: "Negative_Sentiment_Drivers",
    purchaseCriteria: "Purchase_Criteria",
    positiveAttributes: "Positive_Attributes",
    negativeAttributes: "Negative_Attributes",
  };

  if (type === "Product") {
    titleMapping.productDimensions = "Product_Dimensions";
  } else {
    titleMapping.brandPillars = "Brand_Pillars";
  }
  const transformed = {};
  for (const [key, items] of Object.entries(data)) {
    const newKey = titleMapping[key] || key;
    transformed[newKey] = items
      ?.filter((item) => item?.selected)
      ?.map((item) => item.text);
  }
  return transformed;
};

export const getNonEmptyKeys = (data) => {
  return Object.keys(data).filter(
    (key) => Array.isArray(data[key]) && data[key].length > 0
  );
};